import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { Box } from "../Box";
import { SharedHover } from "../SharedHover";
import { Text } from "../Text";
import React from 'react';
import styled from 'styled-components';
export function NavGroup(_ref) {
  var label = _ref.label,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["label", "children"]);

  return /*#__PURE__*/React.createElement(Box, other, label && /*#__PURE__*/React.createElement(StyledBox, {
    alignItems: "center",
    display: "flex",
    height: 32,
    paddingTop: 12
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "body",
    color: "grey50"
  }, label)), /*#__PURE__*/React.createElement(SharedHover, {
    transitionDuration: 75
  }, children));
}
var StyledBox = styled(Box).withConfig({
  displayName: "NavGroup__StyledBox",
  componentId: "vapor__m42ns5-0"
})(["padding-bottom:10px;"]);